export class Deal {
    constructor(text, oldPrice, newPrice, photo) {
        this.text = text;
        this.oldPrice = oldPrice;
        this.newPrice = newPrice;
        this.photo = photo;
    }
}